import React from 'react';

const About = () => {
  return (
    <div className="py-12 px-4 bg-gray-900 text-white">
      <div className="max-w-7xl mx-auto">
        <h1 className="text-4xl font-bold mb-8 text-center text-red-500">ABOUT US</h1>
        <div className="prose prose-invert max-w-3xl mx-auto">
          <p>
            Fight Gear was founded in 2010 by a group of professional fighters who were frustrated with the 
            lack of high-quality, durable equipment available on the market. We set out to create gear that 
            could withstand the toughest training sessions and most intense fights.
          </p>
          <p>
            All our products are tested by our team of professional fighters before they hit the market. 
            We work closely with trainers, fighters, and gym owners to ensure our gear meets the needs 
            of the combat sports community.
          </p>
          <p>
            Our mission is to equip fighters at all levels with gear that enhances their performance, 
            protects them from injury, and helps them train smarter and harder.
          </p>
        </div>
      </div>
    </div>
  );
};

export default About;